import React, { useState } from 'react'

import DESKTOP_TUTORIAL_IMAGE from '@public/assets/tutorial/desktop-tutorial.png'
import DESKTOP_TUTORIAL_MAC_IMAGE from '@public/assets/tutorial/desktop-tutorial-mac.png'
import { TutorialImage } from '@features/connectedApps/components/TutorialImage'
import { downloadDesktopAgentInstaller } from '@features/connectedApps/utils/downloadDesktopAgentInstaller'
import { useDeviceStore } from '@stores/useDeviceStore'

const DesktopAgentAccessStep = () => {
  const [isDownloading, setIsDownloading] = useState(false)

  const isMacDesktop = useDeviceStore(state => state.isMacDesktop)

  const tutorialImage = isMacDesktop
    ? DESKTOP_TUTORIAL_MAC_IMAGE
    : DESKTOP_TUTORIAL_IMAGE
  const platform = isMacDesktop ? 'Mac' : 'Windows'

  const handleDownload = async () => {
    if (isDownloading) return

    setIsDownloading(true)
    try {
      await downloadDesktopAgentInstaller()
    } catch (error) {
      console.error('Failed to download Desktop Agent installer', error)
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <div className="max-w-[900px]">
      <TutorialImage
        align="left"
        alt={`MIRA Desktop Agent installation guide for ${platform}`}
        height={717}
        maxHeight={560}
        src={tutorialImage}
        width={1040}
      />
      <button
        className="mt-4 inline-flex h-10 items-center rounded-full bg-[#333] px-4 text-sm font-semibold text-white hover:bg-black disabled:cursor-not-allowed disabled:opacity-60"
        disabled={isDownloading}
        onClick={handleDownload}
        type="button"
      >
        {isDownloading ? 'Downloading…' : '↓ Download'}
      </button>
    </div>
  )
}

export default DesktopAgentAccessStep
